import { useState, useEffect, useRef } from 'react';
import _size from 'lodash/size';

export default function useOverlayDetection() {
  const [overlayDetected, setOverlayDetected] = useState(false);
  const timer = useRef();

  const overlayDetector = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      // MUI modal component
      const overlay1 = document.querySelectorAll('[role="presentation"]');
      // MUI popover component
      const overlay2 = document.querySelectorAll('[role="tooltip"]');

      setOverlayDetected(!!(_size(overlay1) || _size(overlay2)));
    }, 500);
  };

  useEffect(() => {
    overlayDetector();
    document.body.addEventListener('mouseup', overlayDetector);

    return () => {
      document.body.removeEventListener('mouseup', overlayDetector);
    };
  }, []);

  return overlayDetected;
}
